import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { UrAddPage } from '../ur-add/ur-add'
import { GlobalsProvider } from '../../providers/globals/globals';

import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/timeout';
import { LoadingController } from 'ionic-angular';

@Component({
  selector: 'page-info',
  templateUrl: 'info.html',
})
export class InfoPage {

  id: string;    
  item: any;
  items: any;
  error: string;
  title: string;
  root_name: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public params: GlobalsProvider,
    public loadingCtrl: LoadingController,
    public http: Http
  ) {

    this.title = 'Полезная информация';
    this.root_name = '';

    this.id = navParams.get('id');

    if (navParams.get('root_title')) {
      this.root_name = navParams.get('root_title');
    }

    let loadingPopup = this.loadingCtrl.create({
      content: ''
    });

    loadingPopup.present();
    console.log(this.params.apiURL + '?act=info&id_lang=' + this.params.id_lang + '&id=' + this.id);
    this.http.get(this.params.apiURL + '?act=info&id_lang=' + this.params.id_lang + '&id=' + this.id)
      .timeout(20000)
      .map(res => res.json())
      .subscribe(
        data => {
            console.log(data);
            this.item = data.item;
            if (this.root_name == '') this.title = this.item.name;
            else this.title = this.root_name; 
            this.items = data.items;
            this.error = "0";

            loadingPopup.dismiss();

        },

        err => {
          loadingPopup.dismiss();
          this.error = "1";
        }

      );
  }


  itemShow(item) {
    // That's right, we're pushing to ourselves!
    this.navCtrl.push(InfoPage, {
      id: item.id,
      root_title: this.item.name
    });
  }

  addQ() {
    // That's right, we're pushing to ourselves!
    this.navCtrl.push(UrAddPage);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InfoPage');
  }

  ionViewWillEnter() {
    this.params.stat('info');    
  }   

}



// WEBPACK FOOTER //
// ./src/pages/info/info.ts